import React, { useMemo, useState } from 'react';

import useResourceLoader from '../util/useResourceLoader';
import UWEEntityApi from '../api/UWEEntityApi';
import Loader from './Loader';
import Notification from './Notification';

import CurrentUWEEntityForm from '../blc/CurrentUWEEntityForm';
import useTitle from '../util/useTitle';
import WorkflowApi from '../api/WorkflowApi';

type OnSubmit=any;
type EntityType=any;
type WorkflowInfo=any;
type UWEEntity = {
  metadata: Record<string, any>
  status: {
    canWork: boolean    
  }[]
}

function PopupDesktopNotificationUWEEntity({ id, slug, onSubmit, entityType, workflowInfo }: {
  id: number,
  slug?: string,
  onSubmit: OnSubmit,
  entityType?: EntityType,
  workflowInfo: WorkflowInfo
}) {
  const [wfToken, loadingWFToken, errorLoadingWFToken] = useResourceLoader(async () => (
    await (UWEEntityApi.createWfAccessTokenHash as any)({uweEntityId: id, canView: true})
  ), [UWEEntityApi, id]);

  const [currentUWEEntity, loadingUWEEntity, errorLoadingUWEEntity] = useResourceLoader(async () => (
    await UWEEntityApi.getUWEEntity({ entityId: id, wfAccessToken : wfToken }) as UWEEntity
  ), [], null);

  const loading = loadingWFToken || loadingUWEEntity; 
  const error = errorLoadingWFToken || errorLoadingUWEEntity;

  const statuses = useMemo(() => currentUWEEntity && currentUWEEntity.status.filter(status => status.canWork), [currentUWEEntity]);
  const currentStatus = statuses ? statuses[0] : null;

  useTitle(currentUWEEntity?.metadata?.number || entityType);

  return (
    <>
      {loading ? (
        <Loader fullscreen />
      ) : error ? (
        <Notification color="danger">{JSON.stringify(error)}</Notification>
      ) : !currentUWEEntity ? (
        <Notification color="danger">
          {entityType} no encontrada. Esto debe ser un error, por favor contacte a la administraci&oacute;n).
        </Notification>
      ) : (
        <div>
          <CurrentUWEEntityForm
            slug={slug}
            viewForm={workflowInfo.viewForm}
            hide={false}
            currentEntity={currentUWEEntity}
            currentStatus={currentStatus}
            onSubmit={onSubmit}
            wfAccessToken={wfToken}
            hideSideTabs
          />
        </div>
      )}
    </>
  );
}

export default PopupDesktopNotificationUWEEntity;
